<template>
    <div class="ExamCenter">
        <!-- 轮播图片 -->
        <van-swipe :autoplay="3000" indicator-color="#fff">
            <van-swipe-item v-for="(image, index) in images" :key="index">
                <router-link :to="image.navurl">
                    <img :src="image.imgurl" />
                </router-link>
            </van-swipe-item>
        </van-swipe>
        <van-notice-bar background="#ecf9ff" :autoplay="8000" color="#1989fa" left-icon="volume-o" scrollable>
            <a href="https://mp.weixin.qq.com/s/evCQiuRY0hn1yCOySkvOLw">2021年中国音乐家协会贵州考区（暑假） 线上考级报名简章</a>
        </van-notice-bar>
        <!-- 主导航 -->
        <div class="Examnav">
            <router-link v-for="(item, index) in mainnavimg" to="" :key="index" @click.native="PopupDev(item)">
                <!-- <span v-if="item.isshow === 1" class="hot">{{item.status}}</span> -->
                <img :src="item.imgurl" alt="">
            </router-link>
        </div>
        <footerTabber />
    </div>
</template>

<script>
import TopNavBar from '@/components/TopNavBar.vue';
import footerTabber from "@/components/footerTabber.vue";
export default {
    components: {
        TopNavBar,
        footerTabber
    },
    data () {
        return {
            images: [
                { imgurl: require("../assets/banner3.jpg"), navurl: "/ExamApply" },
                { imgurl: require("../assets/banner3.jpg"), navurl: "/VipCenter" }
            ],
            mainnavimg: [
                { name: "在线报名", imgurl: require("../assets/exam01.png"), navurl: "/ExamApply", status: "报名已开启", isshow: 1 },
                { name: "上传视频", imgurl: require("../assets/exam02.png"), navurl: "/ExamList", status: "暂未开始", isshow: 1 },
                { name: "成绩查询", imgurl: require("../assets/exam03.png"), navurl: "/ExamResultInfo", status: "报名已开启", isshow: 1 },
                { name: "查询视频上传时间", imgurl: require("../assets/exam04.png"), navurl: "/ExamTimeInfo", status: "报名已开启", isshow: 1 }
            ]
        }
    },
    methods: {
        PopupDev (item) {
            if (item.isshow == 0) {
                this.$toast.fail("敬请期待！");
                return;
            } else {
                this.$router.push(item.navurl)
            }
        },

    }
}
</script>

<style>
.ExamCenter {
    background: #fff;
    height: 100vh;
    padding: 15px 0;
}
.ExamCenter
    .van-grid
    .van-grid-item
    .van-grid-item__content
    .van-grid-item__icon
    img.van-icon__image {
    width: 100%;
    height: auto;
}
.ExamCenter .van-grid .van-grid-item .van-grid-item__content {
    background: transparent;
}
.Examnav {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin: 0 auto;
    justify-content: center;
}
.Examnav a {
    width: 45%;
    display: inline-block;
    margin: 2%;
    position: relative;
}
.Examnav a img {
    width: 100%;
    display: block;
}
.Examnav a .hot {
    position: absolute;
    width: 15vw;
    top: 10px;
    right: 2vw;
    color: #fff;
    background: rgba(255, 10, 55, 0.8);
    box-shadow: 0px 0px 1px #fff;
    padding: 3px;
    border: solid 1px #fff;
    border-radius: 35px 20px 20px 0;
    font-size: 2.4vw;
}
.ExamCenter
    .van-notice-bar
    .van-notice-bar__wrap
    .van-notice-bar__content
    a:link {
    color: #1989fa;
}
</style>